import type { INetsuiteNotification } from 'src/types/notification';
import { axiosServerData, type NetsuiteInstanceProps } from 'src/utils/axios';

type NotificationsResponse = {
  success: boolean;
  data: INetsuiteNotification[];
  meta: { unreadCount: number };
};

const request = (props: Partial<NetsuiteInstanceProps>) =>
  axiosServerData({
    firstEndPoint: 'notification',
    lastEndPoint: 'root',
    ...props,
  } as NetsuiteInstanceProps);

export const getNotifications = (
  idUser: string,
  config: string,
  status?: 'unread' | 'read' | 'archived'
) =>
  request({
    idUser,
    method: 'get',
    endUrl: `?limit=100${status ? `&status=${status}` : ''}`,
    headers: { config },
  }) as Promise<NotificationsResponse>;

export const markNotificationRead = (idUser: string, config: string, notificationId: string) =>
  request({
    idUser,
    method: 'patch',
    endUrl: `/${notificationId}/read`,
    headers: { config },
  });

export const markAllNotificationsRead = (idUser: string, config: string) =>
  request({
    idUser,
    method: 'patch',
    endUrl: '/read-all',
    headers: { config },
  });

export const archiveNotification = (idUser: string, config: string, notificationId: string) =>
  request({
    idUser,
    method: 'patch',
    endUrl: `/${notificationId}/archive`,
    headers: { config },
  });

